import api from './api';

export interface User {
  _id: string;
  name: string;
  email: string;
  avatar?: string;
}

export const authService = {
  async getCurrentUser(): Promise<User | null> {
    try {
      const response = await api.get<User>('/app/users/me');
      return response.data;
    } catch (error) {
      return null;
    }
  },

  logout() {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  }
}; 